<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-md">
    @if (state() === 'joining') {
      <p class="text-dusk">Joining…</p>
    } @else if (state() === 'need-code') {
      <div class="mb-8">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Join a pool</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Enter an invite code</h1>
        <p class="mt-3 text-dusk">Ask whoever's running the competition for their invite code.</p>
      </div>

      <form
        [formGroup]="form"
        (ngSubmit)="submitCode()"
        class="flex flex-col gap-5 rounded-md border border-hairline bg-panel p-7"
      >
        <div class="flex flex-col gap-2">
          <label for="code" class="text-sm font-medium text-parchment">Invite code</label>
          <input
            id="code"
            type="text"
            formControlName="code"
            class="rounded border border-hairline bg-ink px-4 py-2.5 font-mono uppercase text-parchment placeholder:text-dusk/60 focus:border-gold focus:outline-none"
            placeholder="ABCD1234"
          />
          @if (form.controls.code.invalid && form.controls.code.touched) {
            <p class="text-sm text-wax-bright">Enter an invite code.</p>
          }
        </div>

        <button
          type="submit"
          class="mt-2 inline-flex items-center justify-center rounded-[3px] bg-gradient-to-b from-gold to-gold-dim px-6 py-3 text-sm font-bold text-ink transition hover:-translate-y-px"
        >
          Join
        </button>
      </form>
    } @else if (state() === 'error') {
      <div class="rounded-md border border-wax-bright/40 bg-panel p-9 text-center">
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Couldn't join</span
        >
        <h1 class="font-display text-2xl font-semibold text-parchment">
          That invite didn't work
        </h1>
        <p class="mt-3 text-dusk">{{ errorMessage() }}</p>
        <a
          routerLink="/join"
          class="mt-7 inline-flex items-center justify-center rounded-[3px] border border-hairline px-6 py-3 text-sm font-semibold text-parchment transition hover:border-parchment"
          >Try a different code</a
        >
      </div>
    }
  </div>
</section>
